
import { yearsToDash, cleanPriceValue } from '~/plugins/filters'

export default {
    name: 'HistoryChart',
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
        price: {
            type: Array,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            issCnt: [],
            issDate: [],
            opiCnt: [],
            opiDate: [],
            discCnt: [],
            discDate: [],
            recoCnt: [],
            recoDate: [],
            priceDate: [],
            priceValue: [],
            chart1: undefined,
            chart2: undefined,
        }
    },
    watch: {
        data() {
            // 데이터 들어오면 초기화
            this.issCnt = []
            this.issDate = []
            this.opiCnt = []
            this.opiDate = []
            this.discCnt = []
            this.discDate = []
            this.recoCnt = []
            this.recoDate = []

            // this.chart2.destroy()

            this.pushDateCnt()
            this.drawIssueChart()
        },
        price() {
            this.priceDate = []
            this.priceValue = []

            // this.chart1.destroy()

            this.pushPriceCnt()
            this.drawPriceChart()
        },
    },
    created() {
        this.pushPriceCnt()
        this.pushDateCnt()
    },
    mounted() {
        this.drawPriceChart()
        this.drawIssueChart()
    },
    beforeDestroy() {
        this.chart1.destroy()
        this.chart2.destroy()
    },
    methods: {
        pushDateCnt() {
            // issCnt
            try {
                for (const item of this.data.issCnt) {
                    this.issDate.push(yearsToDash(item.showDate))
                    this.issCnt.push(item.count)
                }
                // discCnt
                for (const item of this.data.discCnt) {
                    this.discDate.push(yearsToDash(item.showDate))
                    this.discCnt.push(item.count)
                }
                // recoCnt
                for (const item of this.data.recoCnt) {
                    this.recoDate.push(yearsToDash(item.showDate))
                    this.recoCnt.push(item.count)
                }
                // opiCnt
                for (const item of this.data.opiCnt) {
                    this.opiDate.push(yearsToDash(item.showDate))
                    this.opiCnt.push(item.count)
                }
            } catch (e) {
                // TODO: error 처리 (list의 length가 0 일 때)
                console.log('error=', e)
            }
        },
        pushPriceCnt() {
            try {
                // price
                for (const item of this.price) {
                    this.priceDate.push(yearsToDash(item.date))
                    this.priceValue.push(cleanPriceValue(item.price))
                }
            } catch (e) {
                // TODO: error 처리 (list의 length가 0 일 때)
                console.log('error=', e)
            }
        },
        drawPriceChart() {
            this.chart1 = window.bb.generate({
                data: {
                    x: 'x',
                    columns: [
                        ['x', ...this.priceDate],
                        ['주가', ...this.priceValue],
                    ],
                },
                padding: {
                    left: 50,
                },
                point: {
                    show: false,
                },
                color: {
                    pattern: ['#6799FF'],
                },
                axis: {
                    x: {
                        type: 'timeseries',
                        tick: {
                            count: 52,
                            format: '%Y-%m-%d',
                        },
                    },
                    y: {
                        label: {
                            text: '(원)',
                            position: 'inner-top',
                        },
                        tick: {
                            format(x) {
                                return window.d3.format(',')(x)
                            },
                        },
                    },
                },
                bindto: this.$refs.chart1,
            })
            this.chart1.zoom.enable(false)
        },
        drawIssueChart() {
            this.chart2 = window.bb.generate({
                data: {
                    xs: {
                        종목이슈: 'x1',
                        공시: 'x2',
                        신규추천: 'x3',
                        투자의견: 'x4',
                    },
                    columns: [
                        ['x1', ...this.issDate],
                        ['x2', ...this.discDate],
                        ['x3', ...this.recoDate],
                        ['x4', ...this.opiDate],
                        ['종목이슈', ...this.issCnt],
                        ['공시', ...this.discCnt],
                        ['신규추천', ...this.recoCnt],
                        ['투자의견', ...this.opiCnt],
                    ],
                    type: 'bubble',
                    labels: true,
                },
                legend: {
                    contents: {
                        bindto: this.$refs.legend,
                        template:
                            "<a style='margin-left:70px;margin-right: -50px;border-radius:3px;color:#fff;padding:12px;background-color:{=COLOR}'>{=TITLE}</a>",
                    },
                },
                bubble: {
                    maxR: 15,
                },
                axis: {
                    x: {
                        type: 'timeseries',
                        tick: {
                            count: 52,
                            format: '%Y-%m-%d',
                        },
                    },
                    y: {
                        label: {
                            text: '(횟수)',
                            position: 'outer-middle',
                        },
                        max: 10,
                    },
                },
                bindto: this.$refs.chart2,
            })
            this.chart2.zoom.enable(false)
        },
    },
}
